import React, { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";

/** Counts up to `value` once the element scrolls into view. */
const Counter = ({ value = 0, suffix = "", duration = 1600, className = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.6 });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView) return undefined;
    let frame;
    const start = performance.now();

    const tick = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setDisplay(Math.round(eased * value));
      if (progress < 1) frame = requestAnimationFrame(tick);
    };

    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [inView, value, duration]);

  return (
    <span ref={ref} className={`tnum ${className}`}>
      {display}
      {suffix}
    </span>
  );
};

export default Counter;
